import { Component, input, model, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/core/services/modal.service';

declare var bootstrap: any;

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './app-info-modal.component.html',
  styleUrl: './app-info-modal.component.scss'
})
export class AppInfoModalComponent implements OnInit, OnDestroy {
  modalId = input.required<string>();
  modalTitle = input.required<string>();
  modalBodyMessage = input.required<string>();
  size = input<string>('none');

  confirmAction = model();

  private modalSubscription: Subscription | undefined;

  constructor(private modalService: ModalService) { }

  ngOnInit(): void {
    this.modalSubscription = this.modalService.modalState$.subscribe(
      (state) => {
        if (state.id === this.modalId()) {
          const modalElement = document.getElementById(state.id);
          if (modalElement) {
            if (state.action === 'open') {
              const modal = new bootstrap.Modal(modalElement);
              modal.show();
            } else if (state.action === 'close') {
              const modal = bootstrap.Modal.getInstance(modalElement);
              if (modal) {
                modal.hide();
              }
            }
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  onCancel() {
    this.confirmAction.set(false);
    this.modalService.close(this.modalId());
  }
}

